<template>
  <div id="wrap">
    <Header/>
    <Scroll/>

    <div class="hp_performanceWrap"> <!-- hp_performanceWrap -->
      <div class="hp_mainSingleTitBox">
        <p>(주)행복을주는사람들의 <span>공연정보 마당</span></p>
        <p>매주 업데이트되는 한류스타 출연 콘서트 및 공연 전시일정 소개</p>
      </div>
      <div class="hp_performanceBox"> <!-- hp_performanceSlider -->
        <ul>
          <li
            v-for="item in statusData.performanceData"
            :key="item.performance_ID">
            <a :href="'/PerformanceDetail?performance_ID=' + item.performance_ID">
              <p class="hp_performanceBox_img">
                <img
                  :src="item.performance_main_image"
                  :alt="item.recommend_banner_title"
                />
              </p>
              <p class="hp_performanceBox_tit">{{item.performance_title}}</p>
              <p class="hp_performanceBox_sub">{{item.performance_sub_title}}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_performance_use
} from '../../ETC/Axios.vue'

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        performanceData: []
      })
    }
  },
  mounted () {
    get_performance_use().then(result_data => {
      this.statusData.performanceData = result_data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Performance/Performance.vue